import { createApiCall2, MethodType, URI } from "../Api";
import { ClassListData } from "models/classList";

export const fetchClassList = (payload: ClassListData) => {
  return createApiCall2(MethodType.GET, URI.USERS.GETCLASSLIST, payload);
};
